import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../store/rootReducer'
import { MemberState } from '../store/member/memberTypings'

const useProtectImages = (dependence: unknown) => {
    const protectedElements = useRef<Element[]>()
    const refInterval = useRef<ReturnType<typeof setInterval> | null>(null)

    const { user } = useSelector<RootState, MemberState>((state) => state.member)

    useEffect(() => {
        protectedElements.current = Array.from(document.querySelectorAll('.onlyForPro'))

        refInterval.current = setInterval(() => {
            protectedElements.current.forEach((item) => {
                if (!getComputedStyle(item).filter.match(/blur/)) item['style'].filter = 'blur(5px)'
                //if (!item.classList.contains('onlyForPro')) item.classList.add('onlyForPro')
            })
        }, 1000)
        return () => {
            clearInterval(refInterval.current)
        }
    }, [dependence, user])
}

export default useProtectImages
